import { CheckIcon, EditIcon } from "@chakra-ui/icons";

import { useState } from "react";
import BookingDataService from "../../services/Booking";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useToast } from "@chakra-ui/react";
import getBookingFormattedDate from "../../Config/Booking";

export const SingleExpertSheetRow = (props: any) => {
  const toast = useToast();
  const { data } = props;
  const {
    booking_date,
    booking_time,
    session_date,
    session_time,
    booking_id,
    booking_type,
    expert_billing_details: { booking_source, isCorporate, expert_price },
    lead_information: { first_name, last_name, email },
    expert_information: { full_name },
    subscription: {
      subscription_sequence,
      session_count,
      subscription_booking_id,
    },
    booking_status,
    post_session_status,
  } = data;

  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];

  const [isEditable, setIsEditable] = useState(false);
  const [price, setPrice] = useState(expert_price);

  const getBookingType = (
    sequence: number,
    session_count: string,
    booking_id: string
  ) => {
    if (sequence === 0) {
      return "Single";
    } else {
      return `Use Subscription ${sequence}/${session_count} ${booking_id}`;
    }
  };

  function getYearAndMonth(dateStr: string) {
    const dateParts = dateStr.split("/");

    const month = parseInt(dateParts[0], 10);
    const year = dateParts[2];

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthName = monthNames[month - 1];

    return {
      year: year,
      month: monthName,
    };
  }

  const handleSavePrice = () => {
    BookingDataService.updateBooking(
      {
        expert_billing_details: {
          booking_source,
          isCorporate,
          expert_price: price,
        },
      },
      booking_id
    )
      .then((res) => {
        setIsEditable(false);
        toast({
          position: "top",
          title: "Expert Price Saved Successfully",
          description: "The expert price has been saved successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          position: "top",
          title: "Expert Price Save Failed",
          description:
            "There was an error saving the expert price. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };
  //APP_PERSONAL_SINGLE_SESSION_WITH_SHEFALI BHARDWAJ
  //0    1        2        3     4     5

  return (
    <tr>
      <td>{getYearAndMonth(booking_date).year}</td>
      <td>{getYearAndMonth(booking_date).month}</td>
      <td>{booking_id}</td>
      <td>
        <div>{getBookingFormattedDate(session_date)}</div>
        <div>{session_time}</div>
      </td>
      <td>{booking_type}</td>
      <td>{booking_source}</td>
      <td>{email}</td>
      <td>
        {first_name} {last_name}
      </td>
      <td>
        {getBookingType(
          subscription_sequence,
          session_count,
          subscription_booking_id
        )}
      </td>
      <td>{isCorporate ? "B2C" : "B2B"}</td>
      <td>{full_name}</td>
      <td>{booking_status}</td>
      <td>{post_session_status}</td>

      {!userControls.includes("hideBillingPayments") && (
        <td>
          <Row>
            <Col xs={8}>
              <Form.Control
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                disabled={!isEditable}
                style={{ width: "90px" }}
              />
            </Col>
            <Col xs={3}>
              {isEditable ? (
                <Button className=" sheet_btn" onClick={handleSavePrice}>
                  <CheckIcon />
                </Button>
              ) : (
                <Button
                  className=" sheet_btn"
                  onClick={() => setIsEditable(true)}
                >
                  <EditIcon />
                </Button>
              )}
            </Col>
          </Row>
        </td>
      )}
    </tr>
  );
};

// SingleExpertSheetRow
